export default __webpack_public_path__ + "static/media/Thank you for asking.7d6edd63.mp3";